module.exports = __webpack_public_path__ + "static/media/SWSCRC1-13.ad0c42cb.mp3";